import styled from '@emotion/styled';
import React from 'react';

const StyledAudio = styled.audio`
  width: 100%;
  border-radius: 10px;

  &::-webkit-media-controls-enclosure {
    border-radius: 10px;
  }
`;

class PodcastAudioPlayer extends React.Component {
  componentDidMount() {
    if ('mediaSession' in navigator && this.props.podcastEpisode?.podcast?.podcastImage?.image?.url) {
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: this.props.podcastEpisode.title,
        artist: this.props.podcastEpisode.podcast.title,
        artwork: [
          {
            src: this.props.podcastEpisode.podcast.podcastImage.image.url,
            sizes: '512x512',
            type: 'image/png',
          },
        ],
      });
    }
  }

  render() {
    if (!this.props.podcastEpisode?.mp3?.url) {
      return null;
    }

    return (
      <StyledAudio
        className={this.props.className}
        src={this.props.podcastEpisode.mp3.url}
        controls
        controlsList='nodownload'
      />
    );
  }
}

export default PodcastAudioPlayer;